  
import axios from 'axios'
import qs from 'qs'
import { getToken, setToken, types } from '../Token'
import { responseHandle } from './handle/responseHandle'
import { getfreshToken } from '@/api/user'
// import store from '@/store'

import { Toast } from 'vant'
import store from '@/store'

// Toast.allowMultiple();

let loadingCount = 0
let loading = ''

function toast(type) {
	if (type) {
		loading = Toast({
      type: 'loading',
      forbidClick: true,
      duration: 0,
      className: 'request-loading',
      loadingType: 'spinner',
      icon: require('@/assets/logo3.png')
    })
	} else {
		loading.clear()
	}
}

const PlatForm = process.env.VUE_APP_PLATFORM //商城项目名称  GZBANK KWTO

const service = axios.create({
	baseURL: process.env.VUE_APP_API_BASE_URL,
	timeout: 10000
})

window.isRefreshing = false

// 蛋糕请求config 处理
function cekeConfigUrlParams () {
	if (store.getters.location) {
		const { province, city, district } = store.getters.location
		return {
			// province,
			city_name: city
			// district
		}
	}
	return {}
}


// const platform = store.mutations
   
// 请求 URL config 参数
function congfigRequestUrlAfter(config) {
  let RequestconfigUrlMap = {
    platform: PlatForm
	}
	
	// 副平台请求添加参数
	const main_platform = store.getters.mainPlatform
	if (main_platform) {
		RequestconfigUrlMap.main_plat_id = main_platform
  }
	
	// 蛋糕所有请求添加参数
	if (config.url.indexOf('/cakes') !== -1) {
		RequestconfigUrlMap = {
      ...RequestconfigUrlMap,
      ...cekeConfigUrlParams()
    }
	}
  // 请求 URL config 参数
  let configStr = ''
	for (let key in RequestconfigUrlMap) {
		// 最后不加 &
		if (configStr) {
			configStr += '&'
		}
    configStr += `${key}=${RequestconfigUrlMap[key]}`
  }
  return configStr
}


service.interceptors.request.use(
	(config) => {
			if (getToken(types.Token)) {
				const refreshTime = parseInt(new Date().getTime() / 1000)
				if (
					refreshTime - getToken(types.Expiresat) < 0
					) {
					config.headers[ 'Authorization' ] = `Bearer ${getToken(types.Token)}`
				} else {
					if (
						refreshTime -
							getToken(
								types.Refresh_token_expiresat
							) <
						0
					) {
						if (!window.isRefreshing) {
							window.isRefreshing = true
							let refresh_token = getToken(
								types.Refresh_token
							)
							getfreshToken({
								token: refresh_token
							}).then(res => {
								setToken({
									Token: res.data.data.token,
									Refresh_token:
										res.data.data.refresh_token,
									Refresh_token_expiresat:
										res.data.data
											.refresh_token_expiresat,
									Expiresat:
										res.data.data.expiresat
								})
								window.isRefreshing = true
							})
						} else {
							window.isRefreshing = true
						}
					} else {
						store.dispatch('user/loginOut')
					}
				}
			}

			if (config.showLoading !== false) {
        toast(true)
      }
			// console.log(config.url.indexOf('/cakes'))

		// config.url = config.url + `?platform=${PlatForm}`
		
			const congfigRequestUrl = congfigRequestUrlAfter(config)
			if (congfigRequestUrl) {
        config.url = config.url + `?${congfigRequestUrl}`
      } 
		
		if (config.data) {
				config.data = qs.stringify(config.data)
			}
        // config.url = config.url + `?${configUrlParams()}`

			// console.log(store.getters.location)

			return config
		},
	(error) => {
		toast(false)
		console.log(error)
		return Promise.reject(error)
	}
)

function errorHandle(error) {
	toast(false)
	if (error.message.includes('timeout')) {
		Toast('当前网络异常, 请稍后再试')
	}
	return Promise.reject(error)
}

service.interceptors.response.use((response) => {
	toast(false)
	if (response.data.code > 0) {
		responseHandle(response.data)
		return Promise.reject()
	} else {
		if (response.headers.token) {
			const data = {
				Refresh_token: response.headers.refresh_token,
				Token: response.headers.token,
				Refresh_token_expiresat: response.headers.refresh_token_expiresat,
				Expiresat: response.headers.expiresat
			}
			setToken(data)
		}
		if (
			response.data.data.message &&
			response.data.data.message !== '获取成功' &&
			response.config.showMsg !== false
		) {
			Toast(response.data.data.message)
    }
		return Promise.resolve(response)
	}
}, errorHandle)

export default service
